function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

// class HeaderDrawer extends MenuDrawer {
//   constructor() {
//     super();
//   }

//   openMenuDrawer(summaryElement) {
//     this.header = this.header || document.querySelector('.section-header');
//     this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
//     document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
//     this.header.classList.add('menu-open');

//     setTimeout(() => {
//       this.mainDetailsToggle.classList.add('menu-opening');
//     });

//     summaryElement.setAttribute('aria-expanded', true);
//     trapFocus(this.mainDetailsToggle, summaryElement);
//     document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   }

//   closeMenuDrawer(event, elementToFocus) {
//     super.closeMenuDrawer(event, elementToFocus);
//     this.header.classList.remove('menu-open');
//   }
// }

// customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);



class SearchForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    document.addEventListener('click', (event) => {
      if (!event.composedPath().includes(this)) {
        this.querySelector('details').open = false;
      }
    });
    this.querySelector('summary').addEventListener('click',()=>{
      setTimeout(()=>{
      this.querySelector('input').focus()
      },0)
    })
  }  
}

customElements.define('search-form', SearchForm);

// class SliderComponent extends HTMLElement {
//   constructor() {
//     super();
//     this.slider = this.querySelector('[id^="Slider-"]');
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.enableSliderLooping = false;
//     this.currentPageElement = this.querySelector('.slider-counter--current');
//     this.pageTotalElement = this.querySelector('.slider-counter--total');
//     this.prevButton = this.querySelector('button[name="previous"]');
//     this.nextButton = this.querySelector('button[name="next"]');

//     if (!this.slider || !this.nextButton) return;

//     this.initPages();
//     const resizeObserver = new ResizeObserver(entries => this.initPages());
//     resizeObserver.observe(this.slider);

//     this.slider.addEventListener('scroll', this.update.bind(this));
//     this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
//     this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
//   }

//   initPages() {
//     this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
//     if (this.sliderItemsToShow.length < 2) return;
//     this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
//     this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
//     this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
//     this.update();
//   }

//   resetPages() {
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.initPages();
//   }

//   update() {
//     // Temporarily prevents unneeded updates resulting from variant changes
//     // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
//     if (!this.slider || !this.nextButton) return;

//     const previousPage = this.currentPage;
//     this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

//     if (this.currentPageElement && this.pageTotalElement) {
//       this.currentPageElement.textContent = this.currentPage;
//       this.pageTotalElement.textContent = this.totalPages;
//     }

//     if (this.currentPage != previousPage) {
//       this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
//         currentPage: this.currentPage,
//         currentElement: this.sliderItemsToShow[this.currentPage - 1]
//       }}));
//     }

//     if (this.enableSliderLooping) return;

//     if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
//       this.prevButton.setAttribute('disabled', 'disabled');
//     } else {
//       this.prevButton.removeAttribute('disabled');
//     }

//     if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
//       this.nextButton.setAttribute('disabled', 'disabled');
//     } else {
//       this.nextButton.removeAttribute('disabled');
//     }
//   }

//   isSlideVisible(element, offset = 0) {
//     const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
//     return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const step = event.currentTarget.dataset.step || 1;
//     this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
//     this.slider.scrollTo({
//       left: this.slideScrollPosition
//     });
//   }
// }

// customElements.define('slider-component', SliderComponent);

// class SlideshowComponent extends SliderComponent {
//   constructor() {
//     super();
//     this.sliderControlWrapper = this.querySelector('.slider-buttons');
//     this.enableSliderLooping = true;

//     if (!this.sliderControlWrapper) return;

//     this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
//     if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

//     this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
//     this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
//     this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
//     this.setSlideVisibility();

//     if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
//   }

//   setAutoPlay() {
//     this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
//     this.autoplaySpeed = this.slider.dataset.speed * 1000;

//     this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
//     this.addEventListener('mouseover', this.focusInHandling.bind(this));
//     this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
//     this.addEventListener('focusin', this.focusInHandling.bind(this));
//     this.addEventListener('focusout', this.focusOutHandling.bind(this));

//     this.play();
//     this.autoplayButtonIsSetToPlay = true;
//   }

//   onButtonClick(event) {
//     super.onButtonClick(event);
//     const isFirstSlide = this.currentPage === 1;
//     const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

//     if (!isFirstSlide && !isLastSlide) return;

//     if (isFirstSlide && event.currentTarget.name === 'previous') {
//       this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
//     } else if (isLastSlide && event.currentTarget.name === 'next') {
//       this.slideScrollPosition = 0;
//     }
//     this.slider.scrollTo({
//       left: this.slideScrollPosition
//     });
//   }

//   update() {
//     super.update();
//     this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
//     this.prevButton.removeAttribute('disabled');

//     if (!this.sliderControlButtons.length) return;

//     this.sliderControlButtons.forEach(link => {
//       link.classList.remove('slider-counter__link--active');
//       link.removeAttribute('aria-current');
//     });
//     this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
//     this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
//   }

//   autoPlayToggle() {
//     this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
//     this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
//     this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
//   }

//   focusOutHandling(event) {
//     const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
//     if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
//     this.play();
//   }

//   focusInHandling(event) {
//     const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
//     if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
//       this.play();
//     } else if (this.autoplayButtonIsSetToPlay) {
//       this.pause();
//     }
//   }

//   play() {
//     this.slider.setAttribute('aria-live', 'off');
//     clearInterval(this.autoplay);
//     this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
//   }

//   pause() {
//     this.slider.setAttribute('aria-live', 'polite');
//     clearInterval(this.autoplay);
//   }

//   togglePlayButtonState(pauseAutoplay) {
//     if (pauseAutoplay) {
//       this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
//       this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
//     } else {
//       this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
//       this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
//     }
//   }

//   autoRotateSlides() {
//     const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
//     this.slider.scrollTo({
//       left: slideScrollPosition
//     });
//   }

//   setSlideVisibility() {
//     this.sliderItemsToShow.forEach((item, index) => {
//       const linkElements = item.querySelectorAll('a');
//       if (index === this.currentPage - 1) {
//         if (linkElements.length) linkElements.forEach(button => {
//           button.removeAttribute('tabindex');
//         });
//         item.setAttribute('aria-hidden', 'false');
//         item.removeAttribute('tabindex');
//       } else {
//         if (linkElements.length) linkElements.forEach(button => {
//           button.setAttribute('tabindex', '-1');
//         });
//         item.setAttribute('aria-hidden', 'true');
//         item.setAttribute('tabindex', '-1');
//       }
//     });
//   }

//   linkToSlide(event) {
//     event.preventDefault();
//     const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
//     this.slider.scrollTo({
//       left: slideScrollPosition
//     });
//   }
// }

// customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){
    // if(this.querySelector('select')){
    //   this.querySelectorAll('select').forEach(sel => {
    //     sel.addEventListener('change', ()=>{console.log('ff')});
    //   })
    // }
    this.addEventListener('change', this.onVariantChange);
    
  }  
  updateOptions() {
    //this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);    
    if(this.querySelector('select')){
        this.options = Array.from(document.querySelectorAll('variant-selects select'), (select) => select.value);
    }else{
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  // updateOptions() {
  //   const fieldsets = Array.from(this.querySelectorAll('fieldset'));
  //   this.options = fieldsets.map((fieldset) => {
  //     return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
  //   });
  // }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    //this.updatePickupAvailability();
    this.removeErrorMessage();
    //this.updateVariantStatuses();
    this.updateRadioBtns();
    //this.updateSelects();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateRadioBtns(){
    document.querySelectorAll('variant-radios fieldset').forEach((set,i) => {
      set.querySelectorAll('input').forEach(btn => {
        if(btn.value === this.options[i]){
          btn.checked = true
        }else{
          btn.checked = false
        }
      })
    })
  }
  // updateSelects(){
  //   if(!this.querySelector('select')){
  //     document.querySelectorAll('variant-selects select').forEach((sel,i) => {
  //       // set.querySelectorAll('input').forEach(btn => {
  //       //   if(btn.value === this.options[i]){
  //       //     btn.checked = true
  //       //   }else{
  //       //     btn.checked = false
  //       //   }
  //       // })
  //       sel.value = this.options[i]
  //     })
  //   }  
  // }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // updateVariantStatuses() {
  //   const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
  //   //const inputWrappers = [...this.querySelectorAll('.product-form__input')];
  //   inputWrappers.forEach((option, index) => {
  //     // if (index === 0) return;
  //     // const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
  //     // const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
  //     // const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
  //     const optionInputs = [...document.querySelector('.product__controls').querySelectorAll('select, option')]
  //     const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
  //     //this.setInputAvailability(optionInputs, availableOptionInputsValue)
  //   });
  // }

  // setInputAvailability(listOfOptions, listOfAvailableOptions) {
  //   listOfOptions.forEach(input => {
  //     if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
  //       input.innerText = input.getAttribute('value');
  //     } else {
  //       input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
  //     }
  //   });
  // }

  // updatePickupAvailability() {
  //   const pickUpAvailability = document.querySelector('pickup-availability');
  //   if (!pickUpAvailability) return;

  //   if (this.currentVariant && this.currentVariant.available) {
  //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
  //   } else {
  //     pickUpAvailability.removeAttribute('available');
  //     pickUpAvailability.innerHTML = '';
  //   }
  // }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    // const productForm = section.querySelector('product-form');
    // if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const sliderSource = html.getElementById(`slider-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const sliderDestination = document.getElementById(`slider-${this.dataset.section}`);
        // const selectsSource = html.getElementById(`variant-selects-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const selectsDestination = document.getElementById(`variant-selects-${this.dataset.section}`);

        const selectsSources = html.querySelectorAll('.product__controls variant-selects');
        const selectsDestinations = document.querySelectorAll('.product__controls variant-selects');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        if (sliderSource && sliderDestination) { 
          sliderDestination.innerHTML = sliderSource.innerHTML; 
          sliderDestination.setAttribute('variant',sliderSource.getAttribute('variant'))
        }
        // if (selectsSource && selectsDestination) { 
        //   selectsDestination.innerHTML = selectsSource.innerHTML; 
        // }
        if (selectsSources && selectsDestinations) { 
          selectsSources.forEach((selectsSource,index)=>{
              selectsDestinations[index].innerHTML = selectsSource.innerHTML; 
          })
        }
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    //this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.variantData = this.variantData || JSON.parse(document.querySelector('#variant-data').textContent);
    //console.log(this.variantData)
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  // setInputAvailability(listOfOptions, listOfAvailableOptions) {
  //   listOfOptions.forEach(input => {
  //     if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
  //       input.classList.remove('disabled');
  //     } else {
  //       input.classList.add('disabled');
  //     }
  //   });
  // }
  // updateOptions() {
  //   const fieldsets = Array.from(this.querySelectorAll('fieldset'));
  //   this.options = fieldsets.map((fieldset) => {
  //     return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
  //   });
  // }
}
customElements.define('variant-radios', VariantRadios);
// class VariantSelects extends HTMLElement {
//   constructor() {
//     super();
//   }
//   connectedCallback(){
//       this.querySelectorAll('select').forEach(sel => {
//         sel.addEventListener('change', ()=>{console.log('ff')});
//       })
//   }
// } 
// customElements.define('variant-selects', VariantSelects); 

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// function currencyFormSubmit(event) {
//   event.target.form.submit();
// }

// document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
//   element.addEventListener('change', currencyFormSubmit);
// });

class CustomSelect extends HTMLElement {
  constructor() {
    super();

  }
  connectedCallback(){
    let j;
    let ll;
    let selElmnt;
    let a;
    let b;
    let c;
    const selectEl = this.querySelector('select')

    const closeAllSelect = () => {
      this.classList.remove("select-arrow-active")
      this.querySelector('.select-items').classList.add("select-hide");
    }
    /* Look for any elements with the class "custom-select": */
    // x = document.getElementsByClassName("custom-select");
    // l = x.length;
    // for (i = 0; i < l; i++) { 
    selElmnt = this.querySelector("select");
    ll = selElmnt.length;
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    this.appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 0; j < ll; j++) {
      /* For each option in the original select element,
      create a new DIV that will act as an option item: */
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      //if(j == 0) c.className = "same-as-selected"
      if(selElmnt.options[j].selected) c.className = "same-as-selected"
      c.addEventListener("click", function(e) {
          /* When an item is clicked, update the original select box,
          and the selected item: */
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();

          if(this.closest('variant-selects')){
            this.closest('variant-selects').dispatchEvent(new Event('change'));
          }  
          selectEl.dispatchEvent(new Event('change'));
  
      });
      b.appendChild(c);
    }
    this.appendChild(b);
    a.addEventListener("click", function(e) {
      /* When the select box is clicked, close any other select boxes,
      and open/close the current select box: */
      e.stopPropagation();
      //closeAllSelect();
      this.nextSibling.classList.toggle("select-hide");
      this.parentElement.classList.toggle("select-arrow-active");
    });

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener("click", closeAllSelect);
  }
          //   updateOptions() {
          //     return Array.from(this.querySelectorAll('select'), (select) => select.value);
          // }
  // disconnectedCallback() {
  //   document.removeEventListener("click", closeAllSelect);
  // }
} 
window.customElements.define('custom-select', CustomSelect)




function imageLoaded(img) {
  return new Promise((resolve, reject) => {
    if (img.complete) {
      resolve(img);
    } else {
      img.addEventListener("load", () => {
        resolve(img);
      });
      img.addEventListener("error", () => {
        reject(new Error("Failed to load image"));
      });
    }
  });
}


class ProductIndex extends HTMLElement {
  constructor() {
    super();
    this.productIndexItems = this.querySelectorAll('.product-index a') 
  }
  connectedCallback(){
    this.productIndexItems.forEach(productIndexItem => {
      // preload rollover img
      const imgSrc = productIndexItem.getAttribute('data-rolloverimg')
      const img = new Image();
      img.src = imgSrc

      if(window.matchMedia("(hover: hover) and (pointer: fine)").matches) {  
        productIndexItem.addEventListener('mouseenter',()=>{
          const li = productIndexItem.parentElement
          this.querySelector('ul').classList.add('inuse')
          img.style.opacity = 0;
          li.classList.add('current')
          li.appendChild(img)
          imageLoaded(img).then((loadedImg) => {
  
            // loadedImg.style.top = 0
            // loadedImg.style.bottom = "auto"
            // if(loadedImg.getBoundingClientRect().bottom > window.innerHeight || loadedImg.getBoundingClientRect().bottom < loadedImg.getBoundingClientRect().height){
            //   loadedImg.style.top = "auto"
            //   loadedImg.style.bottom = 0
            // }
  
            loadedImg.style.opacity = 1;
          }).catch((err) => {
            console.error(err);
          })
        })
        productIndexItem.addEventListener('mouseleave',()=>{
          const li = productIndexItem.parentElement
          this.querySelector('ul').classList.remove('inuse')
          li.classList.remove('current')
          li.querySelector('img').remove()
        })
      }else{
          productIndexItem.addEventListener('click',(e)=>{
          const currLi = this.querySelector('li.current');
          const li = productIndexItem.parentElement; 
          if(li !== currLi){
            e.preventDefault();
            e.stopPropagation();
          }
          if(currLi){
            currLi.classList.remove('current')
            currLi.querySelector('img').remove()
          }
          this.querySelector('ul').classList.add('inuse')
          img.style.opacity = 0;
          li.classList.add('current')
          li.appendChild(img)
          imageLoaded(img).then((loadedImg) => {  
            if(loadedImg.getBoundingClientRect().top - 40 + window.scrollY < 40){
              loadedImg.classList.add('below')
            }
            loadedImg.style.opacity = 1;
          }).catch((err) => {
            console.error(err);
          }) 
        }) 
      } 
    })
  }
  // disconnectedCallback() {
  //   this.productIndexItems.forEach(productIndexItem =>{
  //     productIndexItem.removeEventListener()
  //   })
  // }
}
window.customElements.define('product-index', ProductIndex)



class ProductAccordion extends HTMLElement {
  constructor() {
    super();
    this.setContentHeight = ()=>{
      this.style.setProperty('--content-height', this.querySelector('.accordion').scrollHeight+'px')
    }
  }
  connectedCallback(){
    const acc = this.querySelector('.accordion')
    const accHead = acc.querySelector('.accordion-header')

    this.style.setProperty('--content-height', acc.scrollHeight+'px')
    accHead.addEventListener('click',()=>{
      acc.classList.toggle('open')
    })
    window.addEventListener('resize',this.setContentHeight)
  }
  disconnectedCallback() {
    window.removeEventListener('resize',this.setContentHeight)
  }
}
window.customElements.define('product-accordion', ProductAccordion)



class StockistGroup extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('.stockists-group__content');

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
  }
  connectedCallback(){

    this.querySelector('.stockists-group__heading').addEventListener('click',()=>{
      if(window.innerWidth < 750){
        // let start = '0px'
        // let end = content.scrollHeight+'px'
        // if(this.classList.contains('open')){
        //   start = content.scrollHeight+'px'
        //   end = '0px'
        // }
        // if (this.animationSlideToggle) {
        //   console.log('anim running')
        //   this.animationSlideToggle.cancel();
        // }
        // this.animationSlideToggle = content.animate({
        //   height: [start, end]
        // },{
        //   duration: 400,
        //   easing: 'linear'
        // });
        // this.animationSlideToggle.onfinish = () => {
        //   this.classList.toggle('open')
        //   this.animationSlideToggle = null;
        //   console.log('finish')
        // }
        // this.animationSlideToggle.oncancel = () => {
        //   console.log('cancel')
        // }
        if (this.isClosing || !this.classList.contains('open')) {
          this.open();
        // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.classList.contains('open')) {
          this.shrink();
        }
      } 
    })
  }
  // disconnectedCallback() {
  //   window.removeEventListener('resize',this.setContentHeight)
  // }
  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;
    
    // Store the current height of the element
    const startHeight = `${this.content.scrollHeight}px`;
    // Calculate the height of the summary
    const endHeight = `0px`;
    
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.content.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Apply a fixed height on the element
    this.content.style.height = `auto`;
    // Force the [open] attribute on the details element
    this.classList.add('open')
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `0px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.content.scrollHeight}px`;
    
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.content.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    //this.el.open = open;
    if(open){
      this.classList.add('open')
    }else{
      this.classList.remove('open')
    }
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.content.style.height = ''
  }
}
window.customElements.define('stockists-group', StockistGroup)



class TruncateText extends HTMLElement {
  constructor() {
    super();

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
  }
  connectedCallback(){
    if(this.clientHeight < this.scrollHeight){
      var readMore = document.createElement('button')
      readMore.innerText = "Read More"
      readMore.className = 'read-more-btn'
      this.after(readMore)

      readMore.addEventListener('click',()=>{
        if (this.isClosing || !this.classList.contains('open')) {
          this.open();
        } else if (this.isExpanding || this.classList.contains('open')) {
          this.shrink();
        }
      })
    }
  }
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.clientHeight}px`;
    const endHeight = `168px`;
    
    if (this.animation) {
      this.animation.cancel();
    }
    
    this.animation = this.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.style.height = `auto`;
    this.classList.add('open')
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    console.log(this.scrollHeight)
    this.isExpanding = true;
    const startHeight = `168px`;
    const endHeight = `${this.scrollHeight}px`;
    
    if (this.animation) {
      this.animation.cancel();
    }
    
    this.animation = this.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    if(open){
      this.classList.add('open')
    }else{
      this.classList.remove('open')
    }
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.style.height = ''
  }
}
window.customElements.define('truncate-text', TruncateText)



class ProductSlider extends HTMLElement {
  static get observedAttributes() {
    return ['variant'];
  }
  constructor() {
    super();
    this.swiper
  }
  connectedCallback(){
    this.setupSlider()
  }
  attributeChangedCallback(attr, was, value){
    //this.swiper.destroy()
    switch (attr) {
      case "variant":
        if (!value || !was || value == was) return;
        this.setupSlider()
      break;
    }
  }
  disconnectedCallback() {
    this.swiper.destroy()
    window.removeEventListener('resize',this.navResize) 
  }
  pagaintionFraction = ()=>{
    this.querySelector('.pagination-fraction').innerText = this.swiper.activeIndex + 1 + ' / ' + this.swiper.slides.length
  }
  // navResize = ()=>{
  //   if(!this.swiper){
  //     setTimeout(()=>{
  //       //console.log(this.swiper)
  //         this.navResize();
  //     },1)
  //   }
  //   //let activeSlide = this.swiper ? this.swiper.slides[this.swiper.activeIndex].querySelector('img') : this.querySelector('img');
  //   let slideSize = this.swiper.slides[this.swiper.activeIndex].querySelector('img').getBoundingClientRect(); 
  //   const slideNav = this.querySelector('.swiper-nav');
  //   //slideNav.style.width = slideSize.width + "px";
  //   slideNav.style.height = slideSize.height + "px";
  // }
  setupSlider = ()=>{
    const navResize = ()=>{
      // if(!swiper){
      //   setTimeout(()=>{
      //     //console.log(this.swiper)
      //       navResize();
      //   },1)
      // }
      //let activeSlide = this.swiper ? this.swiper.slides[this.swiper.activeIndex].querySelector('img') : this.querySelector('img');
      let slideSize = this.querySelector('.swiper-slide-active img').getBoundingClientRect(); 
      const slideNav = this.querySelector('.swiper-nav');
      //slideNav.style.width = slideSize.width + "px";
      slideNav.style.height = slideSize.height + "px";
    }
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      loop:true,
      pagination: {
        el: this.querySelector('.pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        afterInit: () => {
          //if(window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
            navResize();
          //}
        },
      }
    });
    this.pagaintionFraction()
    this.swiper.on('slideChange', this.pagaintionFraction);

    //if(window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      this.swiper.on('slideChange', navResize);
      window.addEventListener('resize',navResize)
    //}   
  }
}
window.customElements.define('product-slider', ProductSlider)

class RelatedProductsSlider extends HTMLElement {
  constructor() {
    super();
    this.breakpoint = window.matchMedia( '(min-width:750px)' );
    this.swiper;
  }
  connectedCallback(){
    this.breakpoint.addEventListener('change', e => {
      this.breakpointChecker();
    });
    this.breakpointChecker();
  }
  // disconnectedCallback() {
  //   this.swiper.destroy()
  //   window.removeEventListener('resize',this.navResize) 
  // }
  enableSwiper = ()=>{
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 14,
      loop:true
      // initialSlide: 2,
      // slidesPerView: 2
    });  
  }
  breakpointChecker(){
    if ( this.breakpoint.matches === true ) {
      if(this.swiper !== undefined && this.swiper.el){ 
        this.swiper.destroy(true, true);
      }  
      return;
    } else if ( this.breakpoint.matches === false ) {
      return this.enableSwiper();
    }
  }
}
window.customElements.define('related-products-slider', RelatedProductsSlider)


class FoundrySlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: this.querySelector('.pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
    this.captions();
    this.pagaintionFraction()
    this.swiper.on('slideChange', ()=> { 
      this.captions
      this.pagaintionFraction
    });

    this.querySelector('.toggle-fullscreen').addEventListener('click',()=>{
      if(document.fullscreenElement){
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
          document.msExitFullscreen();
        } 
      }else{
        if (this.requestFullscreen) {
          this.requestFullscreen();
        } else if (this.webkitRequestFullscreen) { 
          this.webkitRequestFullscreen();
        } else if (this.msRequestFullscreen) { 
          this.msRequestFullscreen();
        }
      } 
    })
    this.querySelectorAll('.play-pause').forEach(playPauseBtn => {
      playPauseBtn.addEventListener('click',()=>{
        const videoWrap = playPauseBtn.parentElement
        const video = videoWrap.querySelector('video')
        let t;
        if(videoWrap.classList.contains('playing')){
          videoWrap.classList.remove('playing')
          video.pause()
        }else{  
          videoWrap.classList.add('playing')
          video.play()
          videoWrap.addEventListener('mousemove',()=>{
            if(t){
              clearTimeout(t)
            }
            videoWrap.classList.add('show-video-controls')
            t = setTimeout(()=>{
              videoWrap.classList.remove('show-video-controls')
            },1000)
          })
        }  
      })
    })
  }
  disconnectedCallback() {
    this.swiper.destroy()
  }
  captions(){
    const captionEl = this.querySelector('.caption')
    const caption = this.swiper.slides[this.swiper.activeIndex].dataset.caption
    captionEl.innerText = caption
  }
  pagaintionFraction(){
    this.querySelector('.pagination-fraction').innerText = this.swiper.activeIndex + 1 + ' / ' + this.swiper.slides.length
  }
}
window.customElements.define('foundry-slider', FoundrySlider)




class ProjectsList extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){

    this.querySelectorAll('summary').forEach(summary =>{
      summary.addEventListener('click',(e)=>{
        e.preventDefault()
        const projectClicked = summary.parentElement
        if(!projectClicked.open){
          this.swiper.destroy()
          this.querySelectorAll('details[open]').forEach((projectOpen)=>{
            const projectContent = projectOpen.querySelector('.project-content')
            const startHeight = `${projectContent.offsetHeight}px`;
            const endHeight = `0px`;

            projectContent.style.overflow = "hidden"
            // if(animation){
            //   animation.cancel()
            // }
            const animationClose = projectContent.animate({
              height: [startHeight, endHeight]
            },{
              duration: 400,
              easing: 'linear'
            });
            animationClose.onfinish = () => {
              // projectContent.style.opacity = 0
              // const animationClose = projectContent.animate({
              //   height: [startHeight, endHeight]
              // },{
              //   duration: 400,
              //   easing: 'linear'
              // });
              //animationClose.onfinish = () => {
                projectContent.style.overflow = ""
                //projectContent.style.opacity = ""
                projectOpen.open = false
              //}
            }
          });

          const projectContent = projectClicked.querySelector('.project-content')
          const startHeight = `0px`;
          const endHeight = `${projectContent.offsetHeight}px`;

          projectContent.style.overflow = "hidden"
          //projectContent.style.opacity = 0
          projectClicked.open = true
          // if(animation){
          //   animation.cancel()
          // }
          const animationOpen = projectContent.animate({
            height: [startHeight, endHeight]
          },{
            duration: 400,
            easing: 'linear'
          });
          animationOpen.onfinish = () => {
            projectContent.style.overflow = ""
            this.sliderFunc()
            // const animationFade = projectContent.animate({
            //   opacity: [0, 1]
            // },{
            //   duration: 400,
            //   easing: 'linear'
            // });
            // animationFade.onfinish = () => {
            //   this.sliderFunc()
            //   projectContent.style.opacity = ""
            // }  
          }
        }
      })
    })
    this.sliderFunc()
  }
  // disconnectedCallback() {
  //   //this.swiper.destroy()
  // }
  sliderFunc(){
    this.swiper = new Swiper(this.querySelector('details[open] .swiper'), {
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: this.querySelector('details[open] .pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
    this.captions();
    this.pagaintionFraction();
    this.swiper.on('slideChange', ()=>{ 
      this.captions
      this.pagaintionFraction
    });
  }
  captions(){
    const captionEl = this.querySelector('details[open] .caption')
    const caption = this.swiper.slides[this.swiper.activeIndex].dataset.caption
    captionEl.innerText = caption
  }
  pagaintionFraction(){
    this.querySelector('details[open] .pagination-fraction').innerText = this.swiper.activeIndex + 1 + ' / ' + this.swiper.slides.length
  }

  // Accordions // 
  // onClick(e) {
  //   // Stop default behaviour from the browser
  //   e.preventDefault();
  //   // Add an overflow on the <details> to avoid content overflowing
  //   this.el.style.overflow = 'hidden';
  //   // Check if the element is being closed or is already closed
  //   if (this.isClosing || !this.el.open) {
  //     this.open();
  //   // Check if the element is being openned or is already open
  //   } else if (this.isExpanding || this.el.open) {
  //     this.shrink();
  //   }
  // }
}
window.customElements.define('projects-list', ProjectsList)




class ArticleSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: this.querySelector('.pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
    this.captions();
    this.pagaintionFraction()
    this.swiper.on('slideChange', ()=> { 
      this.captions
      this.pagaintionFraction
    });
  }
  disconnectedCallback() {
    this.swiper.destroy()
  }
  captions(){
    const captionEl = this.querySelector('.caption')
    const caption = this.swiper.slides[this.swiper.activeIndex].dataset.caption
    captionEl.innerText = caption
  }
  pagaintionFraction(){
    this.querySelector('.pagination-fraction').innerText = this.swiper.activeIndex + 1 + ' / ' + this.swiper.slides.length
  }
}
window.customElements.define('article-slider', ArticleSlider)


class FeaturedCards extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){
    this.alignCards()
    const that = this
    window.addEventListener('resize',this.alignCards.bind(this))
  }
  disconnectedCallback() {
    window.removeEventListener('resize',this.alignCards)
  }
  alignCards(){
    const cards = this.querySelectorAll('.featured-card')
    cards.forEach(card =>{
      if(card.classList.contains('portrait')){
        let cardToAdjust;
        if(card.nextElementSibling && card.nextElementSibling.classList.contains('landscape')){
          cardToAdjust = card.nextElementSibling
        }
        if(card.previousElementSibling && card.previousElementSibling.classList.contains('landscape')){
          cardToAdjust = card.previousElementSibling
        }
        if(cardToAdjust){
          cardToAdjust.style.marginTop = card.querySelector('img').clientHeight * .5 + "px"
        }
      }
    })
    this.classList.remove('setting-up')
  } 
}
window.customElements.define('featured-cards', FeaturedCards)




function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

// let lastScroll = 0;
// const siteHeader = document.querySelector('.site-header');
// const headerUpDown = () => {
//     const currentScroll = window.pageYOffset;
//     //const siteHeader = document.querySelector('.site-header');
//     if (currentScroll <= 0) {
//     siteHeader.classList.remove('scrolled-up');
//     return;
//     }

//     if (currentScroll > lastScroll && !siteHeader.classList.contains('scrolled-down')) {
//     // down
//     siteHeader.classList.remove('scrolled-up');
//     siteHeader.classList.add('scrolled-down');
//     } else if (
//     currentScroll < lastScroll &&
//     siteHeader.classList.contains('scrolled-down')
//     ) {
//     // up
//     siteHeader.classList.remove('scrolled-down');
//     siteHeader.classList.add('scrolled-up');
//     }
//     lastScroll = currentScroll;   

// }
// window.addEventListener("scroll", headerUpDown)

const init = ()=> {  
  let downloads = document.querySelectorAll('.downloads a')
  if(downloads){
    downloads.forEach(download => {
      fetch(download.href)
        .then(res => res.blob())
        .then(blob => { 
          // console.log(blob)
          // console.log(formatBytes(blob.size, decimals = 2))
          download.querySelector('.filesize').innerText = formatBytes(blob.size, decimals = 2)
        })
    })
  }
  document.querySelector('.mobile-nav').open = false

  const backBtn = document.querySelector('.back-btn')
  if(backBtn){
    let backBtnURLVar
    if(swup.transition.from){
      sessionStorage.setItem("backBtnURL", swup.transition.from);
      backBtnURLVar = swup.transition.from
    }else{
      backBtnURLVar = sessionStorage.getItem('backBtnURL')
    }
    if(backBtnURLVar){
      backBtn.href = backBtnURLVar
    }
  }

  
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });
}

const swup = new Swup({
  plugins: [
    new SwupScriptsPlugin({ optin: true }),
    new SwupScrollPlugin(),
    new SwupBodyClassPlugin(),
    new SwupRouteNamePlugin({
      routes: [
        { name: 'home', path: '/' },
        { name: 'collections', path: '/collections/:slug*' },
        //{ name: 'collections-filter', path: '/collections/:slug/:fiter*' },
        { name: 'project', path: '/projects/:slug' },
        { name: 'product', path: '/products/:slug' },
        { name: 'any', path: '(.*)' }
      ]
    })
  ],
  containers: ['.swup']
});

if (document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => init());
}

swup.on('contentReplaced', init);

